import { getMsalInstance, getMsalClientId, resolveMailcallAccessToken } from './auth/msalConfig';

/** SessionStorage anahtarı — bootstrap tek sefer handleRedirectPromise sonrası */
export const MSAL_MAILCALL_ACCESS_TOKEN_KEY = 'helpdesk_msal_mailcall_access_token';

function isMailcallPath() {
  const path = (window.location.pathname || '/').replace(/\/+$/, '') || '/';
  return path === '/mailcall';
}

/**
 * React render edilmeden önce /mailcall OAuth dönüşünü işler.
 * Böylece handleRedirectPromise yalnızca bir kez çalışır (Strict Mode çift effect sorunu giderilir).
 */
export async function bootstrapMsalMailcall() {
  if (!isMailcallPath()) return;
  // MSAL: handleRedirectPromise her /mailcall yüklemesinde çağrılmalı.
  // Kod çoğu zaman hash'tedir (response_mode=fragment); eski kod sadece ?code aradığı için token hiç kaydedilmiyordu.
  if (!getMsalClientId()) {
    console.warn('bootstrapMsalMailcall: MSAL_CLIENT_ID yok.');
    return;
  }

  try {
    const msal = getMsalInstance();
    await msal.initialize();
    const accessToken = await resolveMailcallAccessToken(msal);
    if (accessToken) {
      sessionStorage.setItem(MSAL_MAILCALL_ACCESS_TOKEN_KEY, accessToken);
    }
  } catch (e) {
    console.error('bootstrapMsalMailcall:', e);
  }
}
